import {
  CastaiUsersV1beta1UserOrganization,
  CastaiUsersV1beta1Organization,
  CastaiUsersV1beta1Membership as OrganizationUser,
  CastaiUsersV1beta1OrganizationType,
} from '@cast/openapi';
export type { CastaiUsersV1beta1ListOrganizationsResponse as OrganizationsResponse } from '@cast/openapi';
import { RequiredProps } from '@cast/shared-types';

export { CastaiUsersV1beta1OrganizationType as OrganizationType };

export enum OrganizationRole {
  owner = 'owner',
  member = 'member',
  analyst = 'analyst',
  viewer = 'viewer',
  enterprise_viewer = 'enterprise-viewer',
  enterprise_owner = 'enterprise-owner',
}

export type Organization = Required<
  Omit<CastaiUsersV1beta1UserOrganization, 'role'>
>;

export type UsersOrganization = Required<CastaiUsersV1beta1Organization>;

export type OrganizationMember = RequiredProps<
  OrganizationUser['user'],
  'id'
> & {
  createdAt?: OrganizationUser['createdAt'];
  loginAt?: OrganizationUser['loginAt'];
  role: OrganizationRole;
  groups?: OrganizationUser['groups'];
};

export type {
  GetSettingsResponse,
  UpdateSettingsResponse,
} from '@cast/openapi-organization-management';
